import React, { createContext, useState, ReactNode, useCallback, useEffect } from 'react';
import { isTokenValid, useApi } from '../utils/globalImports';
import { User } from '../constants/types';

interface AuthContextType {
  isAuthenticated: boolean | null;
  setIsAuthenticated: React.Dispatch<React.SetStateAction<boolean | null>>;
  triggerValidation: () => Promise<void>;
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
}

export const AuthContext = createContext<AuthContextType>({
  isAuthenticated: null,
  setIsAuthenticated: () => { },
  triggerValidation: async () => { },
  user: null,
  setUser: () => { },
});

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { execute } = useApi();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [user, setUser] = useState<User | null>(null);


  const validateToken = useCallback(async () => {
    try {
      const { data } = await execute('get', '/auth/validate');
      if (data) {
        setIsAuthenticated(true);
        return;
      }
      // if (isTokenValid()) {
      //   setIsAuthenticated(true);
      // } 
      else {
        setIsAuthenticated(false);
        localStorage.removeItem('userId');
        localStorage.removeItem('name');
        setUser(null);
      }
    } catch (error) {
      setIsAuthenticated(false);
      localStorage.removeItem('userId');
      localStorage.removeItem('name');
      setUser(null);
    }
  }, [execute]);

  useEffect(() => {
    validateToken();
  }, [validateToken]);

  useEffect(() => {
    // Read from localStorage on first load
    const userId = localStorage.getItem("userId");
    const role = localStorage.getItem("role");
    const name = localStorage.getItem("name") || '';
    const email = localStorage.getItem("email");

    if (userId && role && name && email) {
      const [firstName, lastName] = name.split(' ');
      setUser({
        userId: parseInt(userId),
        role,
        firstName,
        lastName: lastName || '',
        email,
      });
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    const handleAuthFailure = () => {
      setIsAuthenticated(false);
      localStorage.removeItem('userId');
      localStorage.removeItem('name');
      setUser(null);
    };

    window.addEventListener('authFailure', handleAuthFailure);

    return () => {
      window.removeEventListener('authFailure', handleAuthFailure);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated, triggerValidation: validateToken, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};
